import { useState } from 'react';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import MonitorIcon from '@mui/icons-material/Monitor';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const Transacciones = () => {
  const [enabled, setEnabled] = useState(true);

  const enabledButton = (clickEnabled) => {
    setEnabled(clickEnabled);
  };

  return (
    <>
      <div
        className="flex-col bg-white m-10 rounded-lg mt-0 border-r border-b border-l border-gray-400 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r border-gray-400"
        style={{ margin: '20px 10px 10px 10px', height: '32vh' }}
      >
        <p className="p-10 font-medium">Todas las transacciones</p>
        <TreeView
          aria-label="file system navigator"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          sx={{ height: 240, flexGrow: 1, maxWidth: '95%', overflowY: 'auto' }}
        >
          <TreeItem nodeId="1" label="Austin" icon={<MonitorIcon />} onClick={() => enabledButton(true)}>
            <TreeItem nodeId="2" label="austin" icon={<MonitorIcon />} onClick={() => enabledButton(false)} />
            <TreeItem nodeId="3" label="austin" icon={<MonitorIcon />} onClick={() => enabledButton(false)} />
            <TreeItem nodeId="4" label="austin" icon={<MonitorIcon />} onClick={() => enabledButton(false)} />
          </TreeItem>
          <TreeItem nodeId="5" label="Tokyo" icon={<MonitorIcon />} onClick={() => enabledButton(true)}>
            <TreeItem nodeId="10" label="archivo tokyo" icon={<MonitorIcon />} onClick={() => enabledButton(false)} />
            <TreeItem nodeId="6" label="Carpeta 5" icon={<MonitorIcon />} onClick={() => enabledButton(true)}>
              <TreeItem nodeId="8" label="arhivo" icon={<MonitorIcon />} onClick={() => enabledButton(false)} />
              <TreeItem nodeId="11" label="archivo tokyo" icon={<MonitorIcon />} onClick={() => enabledButton(false)} />
              <TreeItem nodeId="12" label="archivo tokyo" icon={<MonitorIcon />} onClick={() => enabledButton(false)} />
              <TreeItem nodeId="13" label="archivo tokyo" icon={<MonitorIcon />} onClick={() => enabledButton(false)} />
            </TreeItem>
          </TreeItem>
          <TreeItem nodeId="14" label="Cork" icon={<MonitorIcon />} onClick={() => enabledButton(true)}>
            <TreeItem nodeId="15" label="archivo cork" icon={<MonitorIcon />} onClick={() => enabledButton(false)} />
            <TreeItem nodeId="16" label="Tokyo" icon={<MonitorIcon />} onClick={() => enabledButton(true)}>
              <TreeItem nodeId="17" label="arhivo" icon={<MonitorIcon />} onClick={() => enabledButton(false)} />
              <TreeItem nodeId="18" label="archivo cork" icon={<MonitorIcon />} onClick={() => enabledButton(false)} />
              <TreeItem nodeId="19" label="archivo cork" icon={<MonitorIcon />} onClick={() => enabledButton(false)} />
              <TreeItem nodeId="20" label="archivo cork" icon={<MonitorIcon />} onClick={() => enabledButton(false)} />
            </TreeItem>
          </TreeItem>
        </TreeView>
      </div>
    </>
  );
};

export default Transacciones;
